<template>
    <td v-if="isColspan" :colspan="field.colspanNum">
      <span class='total'>{{ colspanSumTotal(field) }}</span>
    </td>
    <td v-else>
      <span class='total'>{{ colSum(field.key) }}</span>
    </td>

</template>

<script>
import ReportMixin from '@/components/ReportMixin.vue'

export default {
  name: 'tdTotalWrap',
  components: {
  },
  mixins: [ReportMixin],
  props: {
    field: Object,
    reportData: Array,
    reportFields: Array,
  },

  computed: {
    isColspan(){
      const vm = this
      return ('colspanNum' in vm.field)
    },
  },

  methods: {
  }
}
</script>

<style>
.total {
   font-weight: bold;
}
</style>